import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------
// const THEME_COLOR = '#4285F4';
const THEME_COLOR = '#EB7C2F';


function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}
// Primary theme color
const PRIMARY = {
  lighter: alpha(THEME_COLOR, 0.1),
  light: alpha(THEME_COLOR, 0.3),
  main: THEME_COLOR,
  dark: alpha(THEME_COLOR, 0.8),
  darker: alpha(THEME_COLOR, 0.9),
  contrastText: "#fff",
};


const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
  500_8: alpha("#919EAB", 0.08),
  500_12: alpha("#919EAB", 0.12),
  500_16: alpha("#919EAB", 0.16),
  500_24: alpha("#919EAB", 0.24),
  500_32: alpha("#919EAB", 0.32),
  500_48: alpha("#919EAB", 0.48),
  500_56: alpha("#919EAB", 0.56),
  500_80: alpha("#919EAB", 0.8),
};

const SECONDARY = {
  lighter: "#F3F4F6",
  light: "#9CA3AF",
  main: "#6B7280",
  dark: "#374151",
  darker: "#1F2937",
  contrastText: "#fff",
};

const INFO = {
  lighter: "#DBEAFE",
  light: "#60A5FA",
  main: "#3B82F6",
  dark: "#1D4ED8",
  darker: "#1E3A8A",
  contrastText: "#fff",
};

const SUCCESS = {
  lighter: "#DCFCE7",
  light: "#4ADE80",
  main: "#22C55E",
  dark: "#16A34A",
  darker: "#14532D",
  contrastText: "#fff",
};

const WARNING = {
  lighter: "#FEF3C7",
  light: "#FBBF24",
  main: "#F59E0B",
  dark: "#D97706",
  darker: "#92400E",
  contrastText: "#fff",
};

const ERROR = {
  lighter: "#FEE2E2",
  light: "#F87171",
  main: "#EF4444",
  dark: "#DC2626",
  darker: "#991B1B",
  contrastText: "#fff",
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
};

const palette = {
  common: { black: "#000", white: "#fff" },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  divider: GREY[500_24],
  text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
  background: { paper: "#fff", default: "#F9FAFB", neutral: GREY[200] },
  action: {
    active: GREY[600],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;